import { createTheme } from "@mui/material";

export const muiTheme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: "'Versos', sans-serif",
          fontSize: "14px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Versos', sans-serif",
        },
      },
    },
  },
});
